import { Collection } from 'modules/core/lib/mobx-rest'

import { ITriggerWithConditions, Trigger } from 'modules/automations/store/models/Trigger'

class TriggersCollection extends Collection<Trigger> {
  get cacheKey(): string {
    return 'triggers'
  }

  model() {
    return Trigger
  }

  show(slug: string): Promise<ITriggerWithConditions> {
    return super.fetch({ path: `${Trigger.staticUrl()}/${slug}` })
  }

  filterBySlug(str: string) {
    return this.filter((trigger) => trigger.matches(str))
  }
}

export const triggers: TriggersCollection = new TriggersCollection()
